import { ENVIRONMENTAL_VARIABLES } from '@/utils/Environment';
import { UnleashClient } from 'unleash-proxy-client';

export enum FEATURE_TYPE {
  EMBEDDED_VISUAL_BOARD_API = 'embedded-visual-board-api',
}

class FeatureFlagService {
  unleash: UnleashClient | null;

  constructor() {
    if (ENVIRONMENTAL_VARIABLES.IS_CLOUD) {
      this.unleash = new UnleashClient({
        url: ENVIRONMENTAL_VARIABLES.UNLEASH_URL + '/proxy',
        clientKey: ENVIRONMENTAL_VARIABLES.UNLEASH_CLIENT_KEY,
        refreshInterval: ENVIRONMENTAL_VARIABLES.UNLEASH_REFRESH_INTERVAL,
        appName: ENVIRONMENTAL_VARIABLES.UNLEASH_APP_NAME,
        environment: ENVIRONMENTAL_VARIABLES.UNLEASH_ENVIRONMENT,
      });

      this.unleash.start();
    } else {
      this.unleash = null;
    }
  }

  once(event: string, callback: () => void) {
    if (this.unleash) {
      this.unleash.once(event, callback);
    } else {
      callback();
    }
  }

  setContextField(field: string, value: string) {
    if (this.unleash) {
      this.unleash.setContextField(field, value);
    }
  }

  getContext() {
    if (this.unleash) {
      return this.unleash.getContext();
    }
  }

  isEnabled(flagName: string, defaultValue = false) {
    if (!this.unleash) {
      return defaultValue;
    }
    return this.unleash.isEnabled(flagName);
  }

  getVariant(flagName: string) {
    if (!this.unleash) {
      return { name: 'default' };
    }
    return this.unleash.getVariant(flagName);
  }
}

export const featureFlagService = new FeatureFlagService();
